import { Controller } from "stimulus";

// Dumb, reusable confirm dialog. It only knows how to open/close itself (via the native
// <dialog> element) and reports the user's choice as `confirm`/`cancel` custom events - callers
// decide when to show it and what to do about the answer.
export default class extends Controller {
  open() {
    if (!this.element.open) {
      this.element.showModal();
    }
  }

  close() {
    if (this.element.open) {
      this.element.close();
    }
  }

  confirm() {
    this.dispatch("confirm");
  }

  // Handles both the Cancel button (via click) and native Escape-to-close (via the dialog's
  // own `cancel` event, wired in the template) - either way the caller only ever has to listen
  // for one `cancel` event.
  cancel() {
    this.dispatch("cancel");
  }
}
